import iconDay1001 from './assets/ic_weather_day_1001.svg';
import iconDay113 from './assets/ic_weather_day_113.svg';
import iconDay116 from './assets/ic_weather_day_116.svg';
import iconDay119 from './assets/ic_weather_day_119.svg';
import iconDay122 from './assets/ic_weather_day_122.svg';
import iconDay143 from './assets/ic_weather_day_143.svg';
import iconDay176 from './assets/ic_weather_day_176.svg';
import iconDay179 from './assets/ic_weather_day_179.svg';
import iconDay182 from './assets/ic_weather_day_182.svg';
import iconDay185 from './assets/ic_weather_day_185.svg';
import iconDay200 from './assets/ic_weather_day_200.svg';
import iconDay227 from './assets/ic_weather_day_227.svg';
import iconDay230 from './assets/ic_weather_day_230.svg';
import iconDay248 from './assets/ic_weather_day_248.svg';
import iconDay260 from './assets/ic_weather_day_260.svg';
import iconDay263 from './assets/ic_weather_day_263.svg';
import iconDay266 from './assets/ic_weather_day_266.svg';
import iconDay281 from './assets/ic_weather_day_281.svg';
import iconDay284 from './assets/ic_weather_day_284.svg';
import iconDay293 from './assets/ic_weather_day_293.svg';
import iconDay296 from './assets/ic_weather_day_296.svg';
import iconDay299 from './assets/ic_weather_day_299.svg';
import iconDay302 from './assets/ic_weather_day_302.svg';
import iconDay305 from './assets/ic_weather_day_305.svg';
import iconDay308 from './assets/ic_weather_day_308.svg';
import iconDay311 from './assets/ic_weather_day_311.svg';
import iconDay314 from './assets/ic_weather_day_314.svg';
import iconDay317 from './assets/ic_weather_day_317.svg';
import iconDay320 from './assets/ic_weather_day_320.svg';
import iconDay323 from './assets/ic_weather_day_323.svg';
import iconDay326 from './assets/ic_weather_day_326.svg';
import iconDay329 from './assets/ic_weather_day_329.svg';
import iconDay332 from './assets/ic_weather_day_332.svg';
import iconDay335 from './assets/ic_weather_day_335.svg';
import iconDay338 from './assets/ic_weather_day_338.svg';
import iconDay350 from './assets/ic_weather_day_350.svg';
import iconDay353 from './assets/ic_weather_day_353.svg';
import iconDay356 from './assets/ic_weather_day_356.svg';
import iconDay359 from './assets/ic_weather_day_359.svg';
import iconDay362 from './assets/ic_weather_day_362.svg';
import iconDay365 from './assets/ic_weather_day_365.svg';
import iconDay368 from './assets/ic_weather_day_368.svg';
import iconDay371 from './assets/ic_weather_day_371.svg';
import iconDay374 from './assets/ic_weather_day_374.svg';
import iconDay377 from './assets/ic_weather_day_377.svg';
import iconDay386 from './assets/ic_weather_day_386.svg';
import iconDay389 from './assets/ic_weather_day_389.svg';
import iconDay392 from './assets/ic_weather_day_392.svg';
import iconDay395 from './assets/ic_weather_day_395.svg';
import iconNight1001 from './assets/ic_weather_night_1001.svg';
import iconNight113 from './assets/ic_weather_night_113.svg';
import iconNight116 from './assets/ic_weather_night_116.svg';
import iconNight119 from './assets/ic_weather_night_119.svg';
import iconNight122 from './assets/ic_weather_night_122.svg';
import iconNight143 from './assets/ic_weather_night_143.svg';
import iconNight176 from './assets/ic_weather_night_176.svg';
import iconNight179 from './assets/ic_weather_night_179.svg';
import iconNight182 from './assets/ic_weather_night_182.svg';
import iconNight185 from './assets/ic_weather_night_185.svg';
import iconNight200 from './assets/ic_weather_night_200.svg';
import iconNight227 from './assets/ic_weather_night_227.svg';
import iconNight230 from './assets/ic_weather_night_230.svg';
import iconNight248 from './assets/ic_weather_night_248.svg';
import iconNight260 from './assets/ic_weather_night_260.svg';
import iconNight263 from './assets/ic_weather_night_263.svg';
import iconNight266 from './assets/ic_weather_night_266.svg';
import iconNight281 from './assets/ic_weather_night_281.svg';
import iconNight284 from './assets/ic_weather_night_284.svg';
import iconNight293 from './assets/ic_weather_night_293.svg';
import iconNight296 from './assets/ic_weather_night_296.svg';
import iconNight299 from './assets/ic_weather_night_299.svg';
import iconNight302 from './assets/ic_weather_night_302.svg';
import iconNight305 from './assets/ic_weather_night_305.svg';
import iconNight308 from './assets/ic_weather_night_308.svg';
import iconNight311 from './assets/ic_weather_night_311.svg';
import iconNight314 from './assets/ic_weather_night_314.svg';
import iconNight317 from './assets/ic_weather_night_317.svg';
import iconNight320 from './assets/ic_weather_night_320.svg';
import iconNight323 from './assets/ic_weather_night_323.svg';
import iconNight326 from './assets/ic_weather_night_326.svg';
import iconNight329 from './assets/ic_weather_night_329.svg';
import iconNight332 from './assets/ic_weather_night_332.svg';
import iconNight335 from './assets/ic_weather_night_335.svg';
import iconNight338 from './assets/ic_weather_night_338.svg';
import iconNight350 from './assets/ic_weather_night_350.svg';
import iconNight353 from './assets/ic_weather_night_353.svg';
import iconNight356 from './assets/ic_weather_night_356.svg';
import iconNight359 from './assets/ic_weather_night_359.svg';
import iconNight362 from './assets/ic_weather_night_362.svg';
import iconNight365 from './assets/ic_weather_night_365.svg';
import iconNight368 from './assets/ic_weather_night_368.svg';
import iconNight371 from './assets/ic_weather_night_371.svg';
import iconNight374 from './assets/ic_weather_night_374.svg';
import iconNight377 from './assets/ic_weather_night_377.svg';
import iconNight386 from './assets/ic_weather_night_386.svg';
import iconNight389 from './assets/ic_weather_night_389.svg';
import iconNight392 from './assets/ic_weather_night_392.svg';
import iconNight395 from './assets/ic_weather_night_395.svg';

export const DAY_WEATHER_ICONS = {
  395: iconDay395,
  392: iconDay392,
  389: iconDay389,
  386: iconDay386,
  377: iconDay377,
  374: iconDay374,
  371: iconDay371,
  368: iconDay368,
  365: iconDay365,
  362: iconDay362,
  359: iconDay359,
  356: iconDay356,
  353: iconDay353,
  350: iconDay350,
  338: iconDay338,
  335: iconDay335,
  332: iconDay332,
  329: iconDay329,
  326: iconDay326,
  323: iconDay323,
  320: iconDay320,
  317: iconDay317,
  314: iconDay314,
  311: iconDay311,
  308: iconDay308,
  305: iconDay305,
  302: iconDay302,
  299: iconDay299,
  296: iconDay296,
  293: iconDay293,
  284: iconDay284,
  281: iconDay281,
  266: iconDay266,
  263: iconDay263,
  260: iconDay260,
  248: iconDay248,
  230: iconDay230,
  227: iconDay227,
  200: iconDay200,
  185: iconDay185,
  182: iconDay182,
  179: iconDay179,
  176: iconDay176,
  143: iconDay143,
  122: iconDay122,
  119: iconDay119,
  116: iconDay116,
  113: iconDay113,
  1001: iconDay1001,
};

export const NIGHT_WEATHER_ICONS = {
  395: iconNight395,
  392: iconNight392,
  389: iconNight389,
  386: iconNight386,
  377: iconNight377,
  374: iconNight374,
  371: iconNight371,
  368: iconNight368,
  365: iconNight365,
  362: iconNight362,
  359: iconNight359,
  356: iconNight356,
  353: iconNight353,
  350: iconNight350,
  338: iconNight338,
  335: iconNight335,
  332: iconNight332,
  329: iconNight329,
  326: iconNight326,
  323: iconNight323,
  320: iconNight320,
  317: iconNight317,
  314: iconNight314,
  311: iconNight311,
  308: iconNight308,
  305: iconNight305,
  302: iconNight302,
  299: iconNight299,
  296: iconNight296,
  293: iconNight293,
  284: iconNight284,
  281: iconNight281,
  266: iconNight266,
  263: iconNight263,
  260: iconNight260,
  248: iconNight248,
  230: iconNight230,
  227: iconNight227,
  200: iconNight200,
  185: iconNight185,
  182: iconNight182,
  179: iconNight179,
  176: iconNight176,
  143: iconNight143,
  122: iconNight122,
  119: iconNight119,
  116: iconNight116,
  113: iconNight113,
  1001: iconNight1001,
};
